import services from '../services'
import * as types from './mutation-types'

export default {
  getList ({ commit }, roomId) {
    return services.list(roomId).then(res => {
      commit(types.SET_BANNERS, res.data)
    })
  },
  save ({ commit }, { roomId, formData }) {
    return services.save(roomId, formData).then(res => {
      return res
    })
  },
  update ({ commit }, { roomId, bannerId, formData }) {
    return services.update(roomId, bannerId, formData).then(res => {
      return res
    })
  },
  remove ({ commit }, { roomId, bannerId }) {
    return services.destroy(roomId, bannerId).then(res => {
      return res
    })
  }
}
